import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const INFRA_STATUS = ["AKTIF", "NONAKTIF", "PERBAIKAN"];
export const STATUS_LABEL = { AKTIF: "Aktif", NONAKTIF: "Tidak Aktif", PERBAIKAN: "Perbaikan" };
export const FILL_COLOR = { odc: "#16A34A", ok: "#0055FF", warn: "#F59E0B", full: "#DC2626", off: "#6B7280" };
export const FILL_LABEL = { ok: "ODP", warn: "ODP Hampir Penuh", full: "ODP Penuh", off: "Tidak Aktif" };
export const SELECT_CLS = "h-9 rounded-md border border-[#E5E7EB] bg-white px-2 text-sm";

export function odpLevel(o) {
  if (o.status !== "AKTIF") return "off";
  const cap = o.kapasitas_port || 0;
  if (cap && o.port_terpakai >= cap) return "full";
  if (cap && o.port_terpakai / cap >= 0.75) return "warn";
  return "ok";
}

export const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

// Tambah/edit ODC, ODP, kabel: Admin & Koordinator semua wilayah (penempatan tetap per wilayah).
export const canEditInfra = (me) => !!me?.can_manage;

export function canManageWilayah(me, wilayahId) {
  if (!me?.can_manage) return false;
  return me.is_admin || (me.wilayah_ids || []).includes(wilayahId);
}

export function useNetworkRefs() {
  const [refs, setRefs] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    api.get("/network/refs").then((r) => setRefs(r.data)).catch((e) => setError(e?.response?.data?.detail || "Gagal memuat"));
  }, []);
  const wilayahName = (id) => refs?.wilayah.find((w) => w.wilayah_id === id)?.nama_wilayah || (id ? "Wilayah belum valid" : "-");
  const lokasiName = (id) => refs?.locations.find((l) => l.id === id)?.name || "-";
  return { refs, error, wilayahName, lokasiName };
}

export const canSeeNetwork = (user) => ["admin", "koordinator", "teknisi"].includes(user?.role);
export const canManageNetwork = (user) => ["admin", "koordinator"].includes(user?.role);

export const CABLE_JENIS = ["FEEDER", "DISTRIBUSI", "DROP"];
export const CABLE_JENIS_LABEL = { FEEDER: "Feeder", DISTRIBUSI: "Distribusi", DROP: "Drop" };
export const CABLE_WEIGHT = { FEEDER: 5, DISTRIBUSI: 3.5, DROP: 2 };
export const CABLE_COLOR = { AKTIF: "#EA580C", PERBAIKAN: "#EAB308", NONAKTIF: "#9CA3AF" };

const rad = (d) => (d * Math.PI) / 180;
export function pathLength(path) {
  let m = 0;
  for (let i = 1; i < path.length; i++) {
    const [a, b] = [path[i - 1], path[i]];
    const h = Math.sin(rad(b[0] - a[0]) / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(rad(b[1] - a[1]) / 2) ** 2;
    m += 2 * 6371000 * Math.asin(Math.sqrt(h));
  }
  return Math.round(m);
}
export const fmtLen = (m) => (m == null ? "-" : m >= 1000 ? `${(m / 1000).toFixed(2)} km` : `${m} m`);

export async function downloadKml(ids, filename) {
  try {
    const res = await api.post("/network/cables/export-kml", { ids }, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    toast.success(`File KML diunduh (${ids.length} kabel)`);
  } catch (err) {
    let msg = "Gagal mengekspor KML";
    try { msg = JSON.parse(await err.response.data.text()).detail || msg; } catch { /* default */ }
    toast.error(msg);
  }
}

export const OLT_TECH = ["GPON", "EPON", "XG-PON", "XGS-PON", "10G-EPON", "LAINNYA"];
export const ONU_STATUS = ["TERPASANG", "CADANGAN", "RUSAK", "DITARIK"];
export const apiError = (err, fallback = "Gagal menyimpan") => {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => (x.msg || "").replace(/^Value error, /, "")).join("; ") : fallback;
};

// Tampilkan hasil sinkron ODC induk ODP dari jalur splitter (respons backend `odc_sync`).
export function notifyOdcSync(sync, toast) {
  [].concat(sync || []).flatMap((x) => (x ? [x, ...(x.downstream || [])] : [])).forEach((x) => {
    if (x.changed) toast.info(`ODC induk ${x.odp_kode || "ODP"} diperbarui otomatis dari jalur splitter: ${x.previous || "(kosong)"} → ${x.odc_kode || "(kosong)"}`);
    else if (x.warning) toast.warning(x.warning, { duration: 8000 });
  });
}

export function oldKodeHit(row, q) {
  const s = (q || "").trim().toLowerCase();
  if (!s || !row?.kode_lama?.length || [row.kode, row.nama].some((v) => (v || "").toLowerCase().includes(s))) return null;
  return row.kode_lama.find((k) => k.toLowerCase().includes(s)) || null;
}
